import api from './api';

export const login = async (username, password) => {
    try {
        const response = await api.post('/api/auth/signin', { username, password });
        return response.data;
    } catch (error) {
        console.log('LOGIN ERROR status:', error?.response?.status);
        console.log('LOGIN ERROR data:', error?.response?.data);
        console.log('LOGIN ERROR message:', error?.message);
        return { result: false, msg: error?.response?.data?.msg ?? 'Error al iniciar sesión.' };
    }
};